import { render } from "./DraftList.vue?vue&type=template&id=495ad471"
import script from "./DraftList.vue?vue&type=script&lang=ts"
export * from "./DraftList.vue?vue&type=script&lang=ts"
script.render = render

export default script